"use client"

import { useEffect } from "react"

const APP_VERSION = "v4.0"

export default function VersionCheck() {
  useEffect(() => {
    try {
      const KEY = 'app-version'
      const prev = localStorage.getItem(KEY)
      if (prev !== APP_VERSION) {
        localStorage.setItem(KEY, APP_VERSION)
        const url = new URL(window.location.href)
        url.searchParams.set('_v', APP_VERSION)
        url.searchParams.set('_cb', String(Date.now()))
        window.location.replace(url.toString())
      }
    } catch {}
  }, [])
  return null
}

